module.exports = __webpack_public_path__ + "public/files/img/eye.2fab0cb1.png";